export default __webpack_public_path__ + "static/media/youthtrams_part_I.049edb1c.pdf";